import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import { S09NewsListingProps } from './S09NewsListing.types';
import { useI18n } from 'next-localization';
import { getCheckbox } from 'src/shared/param-utils';

export type S09NewsListingModel = {
  site?: string;
  section: string[];
  dataModel: {
    shouldDisplaySearchBox: boolean;
    numberOfSearchResultsPerPage: number;
    noResultsText: string;
    searchFieldPlaceholder: string;
    searchFieldLabel: string;
    searchButtonText: string;
    shouldLazyLoad: boolean;
  };
};

export function CreateS09NewsListingModel(props: S09NewsListingProps): S09NewsListingModel {
  const { sitecoreContext } = useSitecoreContext();
  const { t } = useI18n();
  const { fields, params } = props;

  const site = sitecoreContext?.site?.name;

  const section =
    fields?.ScopeSearchToSection?.filter((i) => i.url)?.map((s) => s.url as string) || [];

  return {
    site,
    section,
    dataModel: {
      shouldDisplaySearchBox: getCheckbox(params?.ShouldDisplaySearchBox),
      numberOfSearchResultsPerPage: parseInt(params?.NumberOfSearchResultsPerPage ?? '5'),
      noResultsText: fields?.NoResultsText?.value || '<p>No results found</p>',
      searchFieldPlaceholder: t('NewsListing-SearchFieldPlaceholder') || 'Enter a search term',
      searchFieldLabel: t('NewsListing-SearchFieldLabel') || 'Search news',
      searchButtonText: t('NewsListing-SearchButtonText') || 'Search',
      shouldLazyLoad: getCheckbox(params?.ShouldLazyLoad),
    },
  };
}
